<div
  *ngLet="{
    selected: selected | async,
    selectedValues: selectedValues | async,
    value: value | async
  } as vm"
>
  <div
    [class.selected]="vm.selected"
    rivButton
    [variant]="'ghost'"
    [size]="'medium'"
    (click)="select(vm.selected, vm.selectedValues)"
    [full]="true"
  >
    <div truncate><ng-content></ng-content></div>
  </div>
  <div *ngIf="vm.selected">
    <riv-date-range
      [required]="true"
      [value]="vm.value"
      (valueChange)="value.next($event)"
    ></riv-date-range>
  </div>
</div>
